import { render, staticRenderFns } from "./LfWhiteCounterComponent.vue?vue&type=template&id=ed5599b0&scoped=true"
import script from "./LfWhiteCounterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfWhiteCounterComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LfWhiteCounterComponent.vue?vue&type=style&index=0&id=ed5599b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5599b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed5599b0')) {
      api.createRecord('ed5599b0', component.options)
    } else {
      api.reload('ed5599b0', component.options)
    }
    module.hot.accept("./LfWhiteCounterComponent.vue?vue&type=template&id=ed5599b0&scoped=true", function () {
      api.rerender('ed5599b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/counters/LfWhiteCounterComponent.vue"
export default component.exports